import { INSPECTION_CHECKLIST_STEPS } from "./inspection-form.catalog";

/**
 * Steps do modal da ficha, na ordem de navegação linear (form §7.1, ordens 1–11).
 * O step 0 (cabeçalho) vive no modal de Nova inspeção (form §7.2).
 *
 * Os rótulos do trilho são chaves `inspection.catalog.v1.steps.*` (i18n).
 */
export interface InspectionFormStep {
  stepKey: string;
  label: string;
  /** Step de checklist genérico (renderizado por `InspectionChecklistStep`). */
  isChecklist: boolean;
}

export const INSPECTION_FORM_STEPS: InspectionFormStep[] = [
  { stepKey: "generalData", label: "inspection.catalog.v1.steps.generalData", isChecklist: false },
  { stepKey: "accesses", label: "inspection.catalog.v1.steps.accesses", isChecklist: true },
  {
    stepKey: "damBody",
    label: "inspection.catalog.v1.steps.damBody",
    isChecklist: true,
  },
  { stepKey: "reservoir", label: "inspection.catalog.v1.steps.reservoir", isChecklist: true },
  {
    stepKey: "spillway",
    label: "inspection.catalog.v1.steps.spillway",
    isChecklist: true,
  },
  {
    stepKey: "instrumentation",
    label: "inspection.catalog.v1.steps.instrumentation",
    isChecklist: true,
  },
  { stepKey: "beachCondition", label: "inspection.catalog.v1.steps.beachCondition", isChecklist: true },
  {
    stepKey: "tailingsWaterIntake",
    label: "inspection.catalog.v1.steps.tailingsWaterIntake",
    isChecklist: true,
  },
  {
    stepKey: "conservationState",
    label: "inspection.catalog.v1.steps.conservationState",
    isChecklist: false,
  },
  {
    stepKey: "generalComments",
    label: "inspection.catalog.v1.steps.generalComments",
    isChecklist: false,
  },
  { stepKey: "signatures", label: "inspection.catalog.v1.steps.signatures", isChecklist: false },
];

export const INSPECTION_FORM_STEP_KEYS = INSPECTION_FORM_STEPS.map(
  (step) => step.stepKey,
);

export function inspectionStepIndex(stepKey: string): number {
  return INSPECTION_FORM_STEP_KEYS.indexOf(stepKey);
}

export function isInspectionChecklistStepKey(stepKey: string): boolean {
  return Boolean(INSPECTION_CHECKLIST_STEPS[stepKey]);
}
